import { AppBar, Theme } from '@mui/material'
import Box from '@mui/material/Box'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import React from 'react'
import AuthLogo from '../../assets/authorize.gif'
import BBBLogo from '../../assets/bbb.jpg'
import { BOTTOM_BAR_HEIGHT, useDimensions } from '../../hooks/useDimensions'
import { CONTENT_MAX_WIDTH } from '../../config'
import { FullScreenModalComponent } from './Modals'
import { PrivacyModalComponent } from './Modals/privacy'
import { ReturnCancellationModalComponent } from './Modals/return'

export const FooterBarComponent: React.FC<{
  fullWidth?: boolean
}> = ({ fullWidth = false }) => {
  const [isPrivacyOpen, setIsPrivacyOpen] = React.useState(false)
  const [isReturnOpen, setIsReturnOpen] = React.useState(false)
  const { width } = useDimensions()
  const isSmallSize = width < 1020

  return (
    <AppBar
      position="fixed"
      color="primary"
      sx={{
        top: 'auto',
        bottom: 0,
        bgcolor: (theme: Theme) => theme.palette.divider,
        background:
          'linear-gradient(180deg, rgba(18, 22, 27, 0.96) 0%, rgba(11, 14, 19, 0.99) 100%)',
        borderTop: '1px solid rgba(173, 223, 255, 0.08)',
        boxShadow: '0 -10px 24px rgba(0, 0, 0, 0.22)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Toolbar
        sx={{
          minHeight: `${BOTTOM_BAR_HEIGHT}px !important`,
          width: '100%',
          maxWidth: fullWidth ? 'none' : CONTENT_MAX_WIDTH,
          mx: 'auto',
          px: { xs: 2, sm: 3 },
          flexDirection: 'row',
          justifyContent: 'space-between',
          overflowX: 'auto',
          gap: 3,
        }}
      >
        <Box
          sx={{ alignItems: 'center', display: 'flex', gap: 1, minWidth: 323 }}
        >
          <Typography
            sx={{
              color: 'rgba(192, 232, 255, 0.92)',
              cursor: 'pointer',
              fontSize: isSmallSize ? '0.8rem' : '0.88rem',
              fontWeight: 500,
            }}
            onClick={() => setIsPrivacyOpen(true)}
          >
            Privacy Policy
          </Typography>{' '}
          <Typography sx={{ color: 'rgba(192, 232, 255, 0.38)' }}>|</Typography>
          <Typography
            sx={{
              color: 'rgba(192, 232, 255, 0.92)',
              cursor: 'pointer',
              fontSize: isSmallSize ? '0.8rem' : '0.88rem',
              fontWeight: 500,
            }}
            onClick={() => setIsReturnOpen(true)}
          >
            Return / Cancellation Policy
          </Typography>
        </Box>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            flexDirection: 'column',
            minWidth: 222,
          }}
        >
          <div
            style={{
              fontSize: isSmallSize ? 'x-small' : 'small',
              color: 'rgba(238, 246, 255, 0.9)',
            }}
          >
            Website By: Rudy Sanchez
          </div>
          <div
            style={{
              fontSize: isSmallSize ? 'x-small' : 'small',
              color: 'rgba(217, 229, 242, 0.72)',
            }}
          >
            Copyright @ 2018 JustLockIt Storage
          </div>
        </Box>
        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            gap: 1.5,
            minWidth: 136,
            opacity: 0.92,
          }}
        >
          <img
            width={isSmallSize ? 35 : 50}
            height="auto"
            src={AuthLogo}
            alt="authLogo"
          />
          <img
            width={isSmallSize ? 55 : 70}
            height="auto"
            src={BBBLogo}
            alt="bbbLogo"
          />
        </Box>
      </Toolbar>
      <FullScreenModalComponent
        isOpen={isPrivacyOpen}
        onClose={() => setIsPrivacyOpen(false)}
        title="Privacy Policy"
      >
        <PrivacyModalComponent />
      </FullScreenModalComponent>
      <FullScreenModalComponent
        isOpen={isReturnOpen}
        onClose={() => setIsReturnOpen(false)}
        title="Return / Cancellation Policy"
      >
        <ReturnCancellationModalComponent />
      </FullScreenModalComponent>
    </AppBar>
  )
}
